import { BroadcastIcon, BookOpenTextIcon, UsersThreeIcon, CheckIcon } from "@phosphor-icons/react";
import { useLang } from "@/context/LangContext";

const PILLARS = [
  { icon: BroadcastIcon, accent: "#0A84FF", kicker: "01" },
  { icon: BookOpenTextIcon, accent: "#32D74B", kicker: "02" },
  { icon: UsersThreeIcon, accent: "#FDB927", kicker: "03" },
];

const COPY = {
  en: [
    { title: "Smarter than the broadcast", desc: "TV gives you the score. Gamly gives you the why — live context the booth never has time for.", points: ["Live win-probability swings", "Matchup and pitch-by-pitch insight", "Stakes for fantasy, playoffs and cards"] },
    { title: "Understand every play", desc: "New to the sport or a lifelong fan, every rule, stat and strategy is explained in plain words.", points: ["Ask any question mid-game", "Stats translated into what they mean", "Answers in English or Spanish"] },
    { title: "Never watch a game alone", desc: "A companion that reacts with you, debates with you and remembers the teams you love.", points: ["Personalities from analyst to hype", "Hot takes and fan debates", "Remembers your teams and players"] },
  ],
  es: [
    { title: "Más inteligente que la transmisión", desc: "La TV te da el marcador. Gamly te da el porqué — el contexto en vivo para el que la cabina nunca tiene tiempo.", points: ["Cambios de probabilidad de victoria en vivo", "Análisis del duelo y de cada lanzamiento", "Lo que está en juego en fantasy, playoffs y tarjetas"] },
    { title: "Entiende cada jugada", desc: "Seas nuevo en el deporte o fan de toda la vida, cada regla, estadística y estrategia se explica en palabras simples.", points: ["Pregunta lo que quieras durante el partido", "Estadísticas traducidas a lo que significan", "Respuestas en inglés o español"] },
    { title: "Nunca veas un partido solo", desc: "Un compañero que reacciona contigo, debate contigo y recuerda a los equipos que amas.", points: ["Personalidades, de analista a pura emoción", "Opiniones picantes y debates entre fans", "Recuerda a tus equipos y jugadores"] },
  ],
};

export default function CompanionPillars() {
  const { lang } = useLang();
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="companion-pillars">
      {PILLARS.map((p, i) => {
        const c = COPY[lang][i];
        return (
          <div
            key={p.kicker}
            data-testid={`pillar-${p.kicker}`}
            className="fade-up group relative p-7 rounded-md bg-[#0f0f0f] border border-white/10 hover:border-white/25 hover:-translate-y-1 transition-[transform,border-color] duration-300"
            style={{ animationDelay: `${i * 120}ms` }}
          >
            <div className="flex items-center justify-between mb-6">
              <p.icon weight="bold" size={30} style={{ color: p.accent }} />
              <span className="font-num text-5xl font-black text-white/[0.06] group-hover:text-white/10 transition-colors">{p.kicker}</span>
            </div>
            <h3 className="font-display font-bold text-2xl uppercase tracking-tight mb-2">{c.title}</h3>
            <p className="text-sm text-white/60 font-medium mb-5">{c.desc}</p>
            <ul className="space-y-2">
              {c.points.map((pt) => (
                <li key={pt} className="flex items-start gap-2 text-sm text-white/80">
                  <CheckIcon weight="bold" size={14} className="mt-1 shrink-0" style={{ color: p.accent }} /> {pt}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
